/* ============================================================
   pbp-ticker.js
   Turns the "Powered by Physics" card grid into a seamless
   horizontal ticker of icon + label.

   The section renders three .pbp-card elements inside .pbp-grid.
   We lift those out, wrap one copy in a .pbp-track, then repeat the
   track enough times to cover twice the viewport width and set
   --pbp-shift to exactly one track width. The CSS animation slides
   the whole marquee by that amount, so it wraps with no visible seam
   and no gap even when three short items are narrower than the screen.

   Recomputed on resize because the number of copies needed depends
   on the viewport.

   Loaded from snippets/meta-tags.liquid, product pages only.
   ============================================================ */
(function () {
  'use strict';

  var instances = [];
  var resizeTimer = null;

  function layout(inst) {
    var grid = inst.grid;

    var existing = grid.querySelector('.pbp-marquee');
    if (existing) existing.parentNode.removeChild(existing);

    var marquee = document.createElement('div');
    marquee.className = 'pbp-marquee';

    var track = document.createElement('div');
    track.className = 'pbp-track';
    inst.cards.forEach(function (card) {
      track.appendChild(card.cloneNode(true));
    });
    marquee.appendChild(track);
    grid.appendChild(marquee);

    /* One track must be measured in place before we know how many
       copies are needed. */
    var trackWidth = track.getBoundingClientRect().width;
    var gridWidth = grid.getBoundingClientRect().width;

    var copies = 2;
    if (trackWidth > 0 && gridWidth > 0) {
      copies = Math.max(2, Math.ceil((gridWidth * 2) / trackWidth));
    }

    for (var i = 1; i < copies; i++) {
      var clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      marquee.appendChild(clone);
    }

    marquee.style.setProperty('--pbp-shift', 100 / copies + '%');
    inst.copies = copies;
  }

  function setup(grid) {
    var cards = Array.prototype.slice.call(grid.children).filter(function (el) {
      return el.classList && el.classList.contains('pbp-card');
    });
    if (!cards.length) return;

    /* Keep the originals as templates, then take them out of the flow
       so only the marquee renders. */
    cards.forEach(function (card) {
      if (card.parentNode) card.parentNode.removeChild(card);
    });

    var inst = { grid: grid, cards: cards, copies: 0 };
    instances.push(inst);
    layout(inst);
  }

  function start() {
    var grids = document.querySelectorAll('.pbp-grid');
    for (var i = 0; i < grids.length; i++) setup(grids[i]);

    if (!instances.length) return;

    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        instances.forEach(layout);
      }, 200);
    }, { passive: true });

    window.rqPbpTicker = instances;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
